import { render } from "./RegulationFooterLink.vue?vue&type=template&id=5bc437cc&scoped=true"
import script from "./RegulationFooterLink.vue?vue&type=script&lang=js"
export * from "./RegulationFooterLink.vue?vue&type=script&lang=js"

import "./RegulationFooterLink.vue?vue&type=style&index=0&id=5bc437cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc437cc"]])

export default __exports__